import i18n from 'i18next';
export default function charCountRenderer(value, maxLength) {
  if (value.length > maxLength - 15) {
    // COUNTDOWN_THRESHOLD: When you get within 15 characters of the limit, the readout switches from the general "Max Y characters" to a more specific "X of Y characters used" text.
    return i18n.t('actions_characters_used', {
      valueLength: value.length,
      maxLength: maxLength
    });
  } else {
    return i18n.t('actions_max_characters', {
      maxLength: maxLength
    });
  }
}